document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth > 768) return;

  var slider = document.querySelector(".pdp-recommend .recommend-content");
  var cards = slider ? slider.querySelectorAll(".product-card") : [];
  if (!slider || cards.length === 0) return;

  // 清理旧箭头
  var arrowsWrap = slider.parentNode.querySelector(".recommend-arrows");
  if (arrowsWrap) arrowsWrap.remove();
  arrowsWrap = document.createElement("div");
  arrowsWrap.className = "recommend-arrows";
  slider.parentNode.appendChild(arrowsWrap);

  // 创建左右按钮
  var leftBtn = document.createElement("button");
  leftBtn.className = "icon-slideshow-arrow recommend-arrow left";
  leftBtn.innerHTML = `<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.8947 0C5.2851 0.390998 5.2851 1.02493 4.8947 1.41593L1.3161 5L4.8947 8.58407C5.2851 8.97507 5.2851 9.609 4.8947 10L0.255775 5.35398C0.0605749 5.15848 0.0605749 4.84152 0.255775 4.64602L4.8947 0Z" fill="black"/></svg>`;
  leftBtn.disabled = true;
  var rightBtn = document.createElement("button");
  rightBtn.className = "icon-slideshow-arrow recommend-arrow right";
  rightBtn.innerHTML = `<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.1053 10C0.7149 9.609 0.7149 8.97507 1.1053 8.58407L4.6839 5L1.1053 1.41593C0.7149 1.02493 0.7149 0.390998 1.1053 0L5.74422 4.64602C5.93943 4.84152 5.93943 5.15848 5.74422 5.35398L1.1053 10Z" fill="black"/></svg>`;
  arrowsWrap.appendChild(leftBtn);
  arrowsWrap.appendChild(rightBtn);

  // 动态获取卡片宽度+间隙
  function getCardWidthWithGap() {
    var card = slider.querySelector(".product-card");
    if (!card) return 0;
    var style = window.getComputedStyle(card);
    var cardWidth = card.getBoundingClientRect().width;
    var gap = parseFloat(style.marginRight) || 0;
    var parentGap = parseFloat(window.getComputedStyle(slider).columnGap) || 0;
    return cardWidth + Math.max(gap, parentGap);
  }
  // 动态获取每页可见卡片数
  function getPerPage() {
    var listRect = slider.getBoundingClientRect();
    console.log("listRect", listRect.width);
    var style = getComputedStyle(slider);
    var paddingLeft = parseFloat(style.paddingLeft);
    var paddingRight = parseFloat(style.paddingRight);
    var cardWidth = getCardWidthWithGap();
    var parentGap = parseFloat(style.columnGap) || 0;
    console.log("cardWidth", cardWidth, parentGap);
    if (!cardWidth) return 1;
    console.log(
      Math.max(
        1,
        Math.floor((listRect.width - paddingLeft + parentGap + 1) / cardWidth)
      )
    );
    return Math.max(
      1,
      Math.floor((listRect.width - paddingLeft + parentGap + 1) / cardWidth)
    );
  }

  var currentIndex = 0;
  var count = cards.length;

  function updateCards() {
    var perPage = getPerPage();
    var maxIndex = Math.max(0, count - perPage);
    currentIndex = Math.max(0, Math.min(currentIndex, maxIndex));
    var centerStart = currentIndex;
    var centerEnd = centerStart + perPage;
    cards.forEach(function (card, idx) {
      if (idx >= centerStart && idx < centerEnd) {
        card.classList.remove("outside");
      } else {
        card.classList.add("outside");
      }
    });
    leftBtn.disabled = currentIndex === 0;
    rightBtn.disabled = currentIndex >= maxIndex;
    if (currentIndex >= maxIndex) {
      slider.classList.add("at-end");
    } else {
      slider.classList.remove("at-end");
    }
  }

  function scrollToIndex(idx) {
    var cardWidthWithGap = getCardWidthWithGap();
    var perPage = getPerPage();
    var maxIndex = Math.max(0, count - perPage);
    var targetIdx = Math.max(0, Math.min(idx, maxIndex));
    currentIndex = targetIdx;
    var scrollLeft = targetIdx * cardWidthWithGap;
    slider.scrollTo({ left: scrollLeft, behavior: "smooth" });
    updateCards();
  }

  leftBtn.addEventListener("click", function () {
    if (currentIndex > 0) scrollToIndex(currentIndex - 1);
  });
  rightBtn.addEventListener("click", function () {
    var perPage = getPerPage();
    var maxIndex = Math.max(0, count - perPage);
    if (currentIndex < maxIndex) scrollToIndex(currentIndex + 1);
  });

  // 滚动时同步按钮和卡片状态
  slider.addEventListener("scroll", function () {
    var cardWidth = getCardWidthWithGap();
    if (!cardWidth) return;
    var perPage = getPerPage();
    var maxIndex = Math.max(0, count - perPage);
    var newIndex = Math.round(slider.scrollLeft / cardWidth);
    newIndex = Math.max(0, Math.min(newIndex, maxIndex));
    if (currentIndex !== newIndex) {
      currentIndex = newIndex;
      updateCards();
    }
  });

  // 初始化
  updateCards();
  setTimeout(updateCards, 50);
  // 图片加载后再刷新一次
  var img = slider.querySelector("img");
  if (img) {
    img.addEventListener("load", function () {
      updateCards();
    });
  }

  // 动态设置滚动区两侧padding，保证内容居中且最大宽度不超过1200px
  function setRecommendSidePadding() {
    var maxContentWidth = 1200;
    var winWidth = document.documentElement.clientWidth;
    var sidePadding = (winWidth - Math.min(winWidth, maxContentWidth)) / 2;
    if (sidePadding < 40) sidePadding = 24;
    slider.style.setProperty("--recommend-side-padding", sidePadding + "px");
  }
  window.addEventListener("resize", setRecommendSidePadding);
  setRecommendSidePadding();
});
